import RotateIndicator from "./RotateIndicator";
import withResponsiveUtils from "../../utils/ResponsiveUtils";

export default withResponsiveUtils(RotateIndicator);
